import React, { useEffect, useState } from "react";
import { Container, Typography, Box, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SubscriptionTable from "./SubscriptionTable";
import SubscriptionLoader from "./SubscriptionLoader";
import SubscriptionError from "./SubscriptionError";
import { useSelector, useDispatch } from "react-redux";
import { setSubscriptions, deleteSubscription } from "../../../Reducer/Subscription/subscriptionPlanSlice";
import AddNewPlans from "./AddNewPlans";

const Subscriptions = () => {
  const dispatch = useDispatch();
  const subscriptionData = useSelector((state) => state.subscriptionPlan.subscriptions);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [addPlanOpen, setAddPlanOpen] = useState(false);
  const [filter, setFilter] = useState("all"); // all | active | inactive

  const fetchSubscriptions = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch('/api/v1/subscription-plan/get-all-active-plans');
      if (!response.ok) throw new Error("Failed to fetch subscriptions");
      const data = await response.json();
      dispatch(setSubscriptions(data.plans || []));
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSubscriptions();
  }, [dispatch]);

  const handleDelete = (deletedId) => {
    dispatch(deleteSubscription(deletedId));
  };

  const handleAddPlanOpen = () => {
    setAddPlanOpen(true);
  };

  const handleAddPlanClose = () => {
    setAddPlanOpen(false);
  };

  const handleAddPlanSuccess = (newPlan) => {
    dispatch(setSubscriptions([...subscriptionData, newPlan]));
  };

  const handleUpdate = () => {
    fetchSubscriptions();
  };

  // Show all plans regardless of filter, status shown in SubscriptionRow
  const filteredPlans = subscriptionData;

  if (loading) return <SubscriptionLoader />;

  // Instead of showing error, show empty state with UI
  // Clear error to avoid showing error component
  if (error) {
    // Optionally, log error to console for debugging
    console.error("Subscription fetch error:", error);
  }

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h5">Subscription Plans</Typography>
        <Button variant="contained" startIcon={<AddIcon />} onClick={handleAddPlanOpen}>
          Add New Plan
        </Button>
      </Box>

      {/* Filter Buttons - For future use */}
      <Box mb={3}>
        <Button
          variant={filter === "all" ? "contained" : "outlined"}
          onClick={() => setFilter("all")}
        >
          All
        </Button>
        <Button
          variant={filter === "active" ? "contained" : "outlined"}
          onClick={() => setFilter("active")}
          sx={{ mx: 1 }}
        >
          Active
        </Button>
        <Button
          variant={filter === "inactive" ? "contained" : "outlined"}
          onClick={() => setFilter("inactive")}
        >
          Inactive
        </Button>
      </Box>

      <SubscriptionTable data={filteredPlans} onDelete={handleDelete} onUpdate={handleUpdate} />
      <AddNewPlans open={addPlanOpen} onClose={handleAddPlanClose} onAdd={handleAddPlanSuccess} />
    </Container>
  );
};

export default Subscriptions;
